import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const assetNavAdapter = createEntityAdapter();
const initialState = assetNavAdapter.getInitialState({
  active: "assets",
  collectionToggled: false,
  redirectTo: "assets",
});

export const assetNavSlice = createSlice({
  name: "assetNav",
  initialState,
  reducers: {
    setCollectionToggled: (state, { payload }) => {
      state.collectionToggled = payload;
      return state;
    },
    setActive: (state, { payload }) => {
      state.active = payload;
      return state;
    },
    setRedirectTo: (state, { payload }) => {
      state.redirectTo = payload;
      return state;
    },
    resetAssetNavState: () => initialState,
  },
});

export const {
  setActive,
  setCollectionToggled,
  setRedirectTo,
  resetAssetNavState,
} = assetNavSlice.actions;

export default assetNavSlice.reducer;
